import { useParams } from "react-router-dom";
import { useGetPageDetailsById } from "./ServerSideStates";

import { Col, Row, Typography } from "antd";

const PageItemDetailsIndex = () => {
  const params = useParams();
  const pageId = params["pageId"];
  const pageDetails = useGetPageDetailsById(pageId || "");
  const{Text} = Typography
  const html = pageDetails?.data?.data?.content ||""

  return <>

  <Col xs={24}>
        <Row gutter={[20, 40]}>
          <Col xs={24}>
            <Row gutter={[20, 20]} className="!bg-[#e7eaed] !p-16">
              <Col xs={24} lg={12} className="!flex !flex-col gap-2">
                <div>
                  <Text className="!text-4xl !font-bold !text-black">
                  {pageDetails?.data?.data?.name || ""}
                  </Text>
                </div>
                <div>
                  <Text className="!text-lg  !text-black cursor-pointer">
                  {pageDetails?.data?.data?.shortDescription || ""}
                  </Text>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={24}>
            <Row className="!px-16" gutter={[20, 20]}>
              <Col xs={24}>
                <div dangerouslySetInnerHTML={{ __html: html }} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
  
  </>
};

export default PageItemDetailsIndex;




